export interface MCFireWorkConfetti {
  p0: number;
  p1: number;
  p2: number;
  p3: number;
  time: number;
  duration: number;
  color: string;
  radius: number;
  density: number;
  width: number;
  height: number;
  completed: boolean;
  Update: Function;
  Draw: Function;
}

export class MCFireWorkConfetti {
  constructor(p0, p1, p2, p3, color = '#FFF', context) {
    let cubeBezier = (p0, c0, c1, p1, t) => {
      var p = new Point(0, 0);
      var nt = 1 - t;

      p.x = nt * nt * nt * p0.x + 3 * nt * nt * t * c0.x + 3 * nt * t * t * c1.x + t * t * t * p1.x;
      p.y = nt * nt * nt * p0.y + 3 * nt * nt * t * c0.y + 3 * nt * t * t * c1.y + t * t * t * p1.y;

      return p;
    };
    const TWO_PI = Math.PI * 2;
    const HALF_PI = Math.PI * 0.5;
    let ease = new Ease();
    this.p0 = p0;
    this.p1 = p1;
    this.p2 = p2;
    this.p3 = p3;
    let sy = 0;
    this.time = 0;
    let x = 0;
    let y = 0;
    this.color = color;
    this.duration = 3 + Math.random() * 2;
    this.width = 8;
    this.height = 6;
    this.completed = false;
    this.Update = () => {
      this.time = Math.min(this.duration, this.time + 1 / 60);

      let f = ease.outCubic(this.time, 0, 1, this.duration);
      let p = cubeBezier(this.p0, this.p1, this.p2, this.p3, f);
      let dx = p.x - x;
      let dy = p.y - y;
      this.radius = Math.atan2(dy, dx) + HALF_PI;
      sy = Math.sin(Math.PI * f * 10);
      x = p.x;
      y = p.y;

      this.completed = this.time === this.duration;
    };
    this.Draw = () => {
      context.save();
      context.translate(x, y);
      context.rotate(this.radius);
      context.scale(1, sy);

      context.fillStyle = this.color;
      context.fillRect(-this.width * 0.5, -this.height * 0.5, this.width, this.height * 2);
      return context.restore();
    };
  }
}

export interface Point {
  x: number;
  y: number;
}
export class Point {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
}

export class Ease {
  constructor() {}
  inCubic(t, b, c, d) {
    t /= d;
    return c * t * t * t + b;
  }

  outCubic(t, b, c, d) {
    t /= d;
    t--;
    return c * (t * t * t + 1) + b;
  }

  inOutCubic(time, start, delta, duration) {
    time /= duration / 2;
    if (time < 1) return (delta / 2) * time * time * time + start;
    time -= 2;
    return (delta / 2) * (time * time * time + 2) + start;
  }
}
